import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "py-2 pl-4" }
const _hoisted_2 = { class: "bg-white mb-2" }
const _hoisted_3 = { class: "bg-white mb-2" }
const _hoisted_4 = { class: "ml-auto pr-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-gray-500 text-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "text-gray-500 text-sm"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-4 ml-2 mr-2 border-l-2 pl-2 border-gray-200"
}
const _hoisted_8 = { class: "p-2 mb-2 text-left rounded-md hover:bg-gray-200 hover:cursor-pointer hover:text-gray-700" }
const _hoisted_9 = {
  href: "#",
  class: "text-gray-500 hover:text-gray-700 hover:underline"
}
const _hoisted_10 = { class: "p-2 mb-2 text-left rounded-md hover:bg-gray-200 hover:cursor-pointer hover:text-gray-700" }
const _hoisted_11 = {
  href: "#",
  class: "text-gray-500 hover:text-gray-700 hover:underline"
}

import i18n from "@/services/i18n";
import {
  CubeTransparentIcon,
  ClipboardDocumentListIcon,
  ChevronUpIcon,
  ChevronDownIcon,
} from "@heroicons/vue/24/outline";
import { ref } from "vue";
import { useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  setup(__props) {

const route = useRoute();
console.log(route.name);

const dropdownMenuVocabulary = ref(
  route.meta.tag === "vocabulary" ? true : false
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'LearnEnglishOverview' },
        "active-class": "text-blue-900 font-bold",
        "exact-active-class": "border-b-1 border-blue-900 font-bold",
        class: "text-lg text-left flex items-center gap-2 text-gray-500 hover:text-gray-700 hover:cursor-pointer"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CubeTransparentIcon), { class: "w-5 h-5" }),
          _createTextVNode(_toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_DROPDOWN.OVERVIEW")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (dropdownMenuVocabulary.value = !dropdownMenuVocabulary.value), ["stop"])),
          class: "text-lg text-left font-semibold flex items-center gap-2 text-gray-500 hover:text-gray-700 hover:cursor-pointer"
        }, [
          _createVNode(_unref(ClipboardDocumentListIcon), {
            class: _normalizeClass(["w-5 h-5", 
              _ctx.$route.meta.tag === 'vocabulary' ? 'text-blue-900 font-bold' : ''
            ])
          }, null, 8, ["class"]),
          _createElementVNode("p", {
            class: _normalizeClass(["flex-1", 
              _ctx.$route.meta.tag === 'vocabulary' ? 'text-blue-900 font-bold' : ''
            ])
          }, _toDisplayString(_unref(i18n).global.t(
                "NAVIGATION_MENU.LANGUAGE_LEARNING_SECTION.ENGLISH_SUBMENU.VOCABULARY"
              )), 3),
          _createElementVNode("div", _hoisted_4, [
            (dropdownMenuVocabulary.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createVNode(_unref(ChevronUpIcon), { class: "w-3 h-3" })
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _createVNode(_unref(ChevronDownIcon), { class: "w-3 h-3" })
                ]))
          ])
        ])
      ]),
      (dropdownMenuVocabulary.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'LearnEnglishListVocabulary' }))),
              class: _normalizeClass([
            _ctx.$route.path.includes('english/tab=list-vocabulary')
              ? ' bg-gray-300 bg-opacity-15 text-blue-900 font-bold'
              : ''
          , "p-2 mb-2 text-left rounded-md hover:bg-gray-200 hover:cursor-pointer hover:text-gray-700"])
            }, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'LearnEnglishListVocabulary' }))),
                class: "hover:text-gray-700 hover:underline"
              }, _toDisplayString(_unref(i18n).global.t(
                "NAVIGATION_MENU.LANGUAGE_LEARNING_SECTION.ENGLISH_SUBMENU.LIST_VOCABULARY"
              )), 1)
            ], 2),
            _createElementVNode("li", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'ListNotePage' }))),
              class: _normalizeClass([
            _ctx.$route.path.includes('english/tab=notes')
              ? ' bg-gray-300 bg-opacity-15 text-blue-900 font-bold'
              : ''
          , "p-2 mb-2 text-left rounded-md hover:bg-gray-200 hover:cursor-pointer hover:text-gray-700"])
            }, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'ListNotePage' }))),
                class: "hover:text-gray-700 hover:underline"
              }, _toDisplayString(_unref(i18n).global.t("NOTE_SECTION.TITLE")), 1)
            ], 2),
            _createElementVNode("li", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'AccountCalendarWork' }))),
              class: _normalizeClass([
            _ctx.$route.path.includes('account/tab=calendar-work')
              ? ' bg-gray-300 bg-opacity-15 text-blue-900 font-bold'
              : ''
          , "p-2 mb-2 text-left rounded-md hover:bg-gray-200 hover:cursor-pointer hover:text-gray-700"])
            }, [
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'AccountCalendarWork' }))),
                class: "hover:text-gray-700 hover:underline"
              }, _toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_DROPDOWN.CALENDAR_WORK")), 1)
            ], 2),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", _hoisted_9, _toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_DROPDOWN.CHANGE_PASSWORD")), 1)
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(i18n).global.t(
                "NAVIGATION_MENU.ACCOUNT_DROPDOWN.SECURITY_AND_PRIVACY"
              )), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})